import React from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { NavLink } from 'react-router-dom';
import { FaInstagram } from "react-icons/fa6";
import { useState } from 'react';
import { useEffect } from 'react';
import { builder } from '../utils/builderWithLocale';
import LanguageSwitcher from './LanguageSwitcher';
import { getLocalizedText } from '../utils/textLocalization';
import EditableField from '../editry/EditableField';

function App({setMode, mode}) {
  const [content, setContent] = useState();

  // Get localized text
  const linksText = getLocalizedText('footer.links');
  const bikesText = getLocalizedText('footer.bikes');
  const socialText = getLocalizedText('footer.social');
  const languageText = getLocalizedText('footer.language');
  const dealersText = getLocalizedText('nav.dealers');
  const contactText = getLocalizedText('nav.contact');
  const aboutText = getLocalizedText('nav.about');
  const officialSiteText = getLocalizedText('footer.official_site');
  const prodlouzenaZaruka = getLocalizedText('footer.prodlouzena_zaruka');
  const gravelText = getLocalizedText('bikes.gravel');
  const mtbText = getLocalizedText('bikes.mtb');
  const roadText = getLocalizedText('bikes.road');
  const cyclocrossText = getLocalizedText('bikes.cyclocross');
  const ebikeText = getLocalizedText('bikes.ebike');
  const pruvodcegravelText = getLocalizedText('nav.pruvodce_gravel');

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    // Check if preloaded footer data is available
    if (window.preloadedHomeData && window.preloadedHomeData.footerData) {
      //("Using preloaded footer data");
      setContent(window.preloadedHomeData.footerData);
    } else {
      // Fallback to fetching footer data
      builder
      .get("footer", {
        cache: true,
        cacheTime: 1800
      })
      .then((data) => {
        setContent(data);
      })
      .catch((error) => console.error("Error fetching footer content:", error));
    }
    
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);

  if (!content?.data) {
    return <div></div>;
  }

  return (
    <div className="footer-lubau" id="footer">
      <hr className="footer-line"/>
        <div id="footer-container" className="footer-lubau-container">
          {/* 
          <div id="footer-info">
          <h1>Ridley</h1>
          <p>IČ: 00000000</p>
          <p>Pepa Novák</p>
          <p>Ulice 123</p>
          <p>100 00 Praha</p>
          <p><BsTelephone /> +420 123 123 123</p>
          </div>
          */}

          <div id="footer-links">
          <h1>{linksText}</h1>
          <NavLink to="/prodejci">{dealersText}</NavLink>
          <NavLink to="/kontakt">{contactText}</NavLink>
          <NavLink to="/o-ridley">{aboutText}</NavLink>
          <NavLink to="/pruvodce/gravel">{pruvodcegravelText}</NavLink>
          <NavLink to="https://www.ridley-bikes.com/en_CZ" target='_blank' rel="noopener noreferrer">{officialSiteText}</NavLink>
          <NavLink to="/prodlouzena-zaruka">{prodlouzenaZaruka}</NavLink>
          </div>

          <div id="footer-links">
          <h1>{bikesText}</h1>
          <NavLink to="/kola/gravel">{gravelText}</NavLink>
          <NavLink to="/kola/mtb">{mtbText}</NavLink>
          <NavLink to="/kola/road">{roadText}</NavLink>
          <NavLink to="/kola/cyklokros">{cyclocrossText}</NavLink>
          <NavLink to="/kola/e-bike">{ebikeText}</NavLink>
          </div>

          <div id="footer-social">
          <h1>{socialText}</h1>
            <div className="footer-social-container">
              <a href={content.data.instagram || "https://example.com"} target='_blank' rel="noopener noreferrer"><FaInstagram /></a>
            </div>
          </div>

          <div id="footer-language">
          <h1>{languageText}</h1>
            <LanguageSwitcher />
          </div>
        </div>

        {/* 
        <div className="footer-switch">
          <label className="switch">
          <input type="checkbox" onChange={() => changeTheme()} defaultChecked={mode === "light"} />
          <span className="slider round">
            <span className="icon sun"><IoIosMoon /></span>
            <span className="icon moon"><FaSun /></span>
          </span>
          </label>
        </div>
        */}
        
        <h2>Copyright © {currentYear}{' '}
          <EditableField model="footer" item={content} field="copyright">
            {content.data.copyright || "loading..."}
          </EditableField>
        </h2>
        <h3>Vyrobila mediální skupina <NavLink to="https://lazylabs.cz/">LazyLabs.cz</NavLink></h3>
    </div>
  );
}

export default App;